import axios from 'axios'

// 创建axios实例
const api = axios.create({
  baseURL: 'http://mentousheji.com/', // 后端服务器地址
  timeout: 1800000, // 30分钟超时时间，确保AI生成任务有足够时间完成
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response
  },
  error => {
    // 对响应错误做点什么
    
    // 处理超时错误
    if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      console.error('请求超时:', error.message)
      // 为AI生成类接口添加特殊提示
      const config = error.config || {}
      if (config.url && (config.url.includes('/cv/process') || config.url.includes('/cv/modify'))) {
        error.isAITimeout = true
        error.friendlyMessage = 'AI生成任务超时，请稍后重试。如果问题持续存在，请联系客服。'
      } else {
        error.friendlyMessage = '请求超时，请检查网络连接后重试。'
      }
    }
    
    // 处理网络错误
    if (!error.response) {
      console.error('网络错误:', error.message)
      error.friendlyMessage = error.friendlyMessage || '网络连接失败，请检查网络后重试。'
    }
    
    // 处理HTTP错误状态
    if (error.response) {
      const status = error.response.status
      switch (status) {
        case 401:
          // token过期或无效，清除本地存储
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          error.friendlyMessage = '登录已过期，请重新登录。'
          // 可以在这里触发登录弹窗或跳转
          break
        case 403:
          error.friendlyMessage = '没有权限执行此操作。'
          break
        case 404:
          error.friendlyMessage = '请求的资源不存在。'
          break
        case 500:
          error.friendlyMessage = '服务器内部错误，请稍后重试。'
          break
        case 502:
        case 503:
        case 504:
          error.friendlyMessage = '服务器暂时不可用，请稍后重试。'
          break
        default:
          error.friendlyMessage = error.response.data?.message || `请求失败 (${status})`
      }
    }
    
    return Promise.reject(error)
  }
)

export default api